import { FILM_SPEEDS } from '../lib/filmScript'
import { useTexte } from '../texte'

/**
 * How much faster a section runs in the film (1.98.0), as a choice from
 * `FILM_SPEEDS`.
 *
 * **One field for two places**, like `VehiclePicker`: the sections of a
 * recording on the map (`SectionsSheet`) and the sections of a day before
 * the day card goes out (`Tagwahl`). From use (1.98.1): "in der
 * Streckenstatistik selbst kann die Geschwindigkeit nicht mehr je Abschnitt
 * eingestellt werden" -- it stood only on the map.
 */
export function SpeedPicker({
  value,
  sectionKey,
  disabled = false,
  onPick,
}: {
  value: number
  /** `first` or the split's id, for the runs. */
  sectionKey: string | number
  disabled?: boolean
  onPick: (speed: number) => void
}) {
  const t = useTexte().karte.sections
  return (
    <label className="sections__speed">
      <span className="field__label">{t.speed}</span>
      <select
        className="field__input"
        name="film_speed"
        value={value}
        disabled={disabled}
        data-speed-of={sectionKey}
        onChange={(e) => onPick(Number(e.target.value))}
      >
        {FILM_SPEEDS.map((speed) => (
          <option key={speed} value={speed}>{t.speedValue(speed)}</option>
        ))}
      </select>
    </label>
  )
}
